import FloatingMessage from '../components/FloatingMessage';

export default function NotFound() {
  return (
    <main className="min-h-screen bg-white">
      <FloatingMessage
        text={'Terjadi kesalahan atau Authentication tidak valid.'}
        type="error"
        show={true}
        duration={3000}
      />
      <div
        className="w-full items-center justify-center bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mx-4 my-4 rounded"
        role="alert"
      >
        <p className="font-bold">404 Tidak Ditemukan</p>
        <p>
          Ups! Link yang kamu akses tidak valid.
          <br />
          Yuk, buka halaman ini lewat aplikasi atau website resmi Smartfren.
        </p>
      </div>
    </main>
  );
}
